
import React, { useState } from 'react';

const InvestmentFAQ: React.FC = () => {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  const faqs = [
    {
      question: 'What is the minimum investment amount?',
      answer: 'The minimum investment amount is $50,000. This allows us to maintain a manageable number of investors while ensuring meaningful participation in our projects.'
    },
    {
      question: 'What returns can I expect from my investment?',
      answer: 'Our target returns range from 15-25% annually, depending on the specific project and market conditions. Returns come from both rental income and property appreciation over the investment period.'
    },
    {
      question: 'How long is the typical investment period?',
      answer: 'Most of our investment opportunities have a 3-5 year timeline. This allows sufficient time for property development, market establishment, and value appreciation before exit.'
    },
    {
      question: 'What are the risks involved in glamping investments?',
      answer: 'Like any real estate investment, glamping involves risks including market fluctuations, weather impacts, regulatory changes, and operational challenges. We mitigate these through diversification, insurance, and experienced management.'
    },
    {
      question: 'How are investment returns distributed?',
      answer: 'Returns are typically distributed monthly from rental income, with additional distributions from refinancing or sale events. All distributions are made proportional to your ownership percentage.'
    },
    {
      question: 'Can I visit the properties I invest in?',
      answer: 'Absolutely! Investors are welcome to visit properties and can often receive discounted rates for personal stays. We encourage investors to experience the properties firsthand.'
    },
    {
      question: 'What happens if I need to exit my investment early?',
      answer: 'While our investments are designed for the full term, we may facilitate early exits through secondary market sales to other qualified investors, subject to certain conditions and potential fees.'
    },
    {
      question: 'How do you select investment properties?',
      answer: 'We use a rigorous selection process evaluating location, market demand, development costs, regulatory environment, and revenue potential. Our team conducts extensive due diligence on every opportunity.'
    },
    {
      question: 'What ongoing involvement is required from investors?',
      answer: 'Our investments are designed to be passive. We handle all day-to-day operations, maintenance, marketing, and guest services. Investors receive regular updates and annual reports.'
    },
    {
      question: 'Are there any tax benefits to glamping investments?',
      answer: 'Real estate investments often provide tax advantages including depreciation deductions and potential 1031 exchanges. We recommend consulting with your tax advisor for specific guidance on your situation.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600">
            Get answers to common questions about investing in glamping properties with OED.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="border border-gray-200 rounded-lg">
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <h3 className="text-lg font-semibold text-gray-900 pr-4">{faq.question}</h3>
                <i className={`ri-${openFAQ === index ? 'subtract' : 'add'}-line text-xl text-emerald-600 flex-shrink-0`}></i>
              </button>
              {openFAQ === index && (
                <div className="px-6 pb-4">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Contact Section */}
        <div className="mt-16 bg-emerald-50 rounded-lg p-8 text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">Still Have Questions?</h3>
          <p className="text-gray-600 mb-6">
            Our investment team is here to help. Schedule a consultation to discuss your specific questions and investment goals.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="/contact"
              className="inline-flex items-center bg-emerald-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              Schedule Consultation
            </a>
            <a 
              href="mailto:Create@oedtinyhomebuilders.com"
              className="inline-flex items-center border border-emerald-600 text-emerald-600 px-6 py-3 rounded-lg font-semibold hover:bg-emerald-600 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line mr-2"></i>
              Email Our Team
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InvestmentFAQ;
